import { render, staticRenderFns } from "./TravelAssistance.vue?vue&type=template&id=f09d80d2&"
import script from "./TravelAssistance.vue?vue&type=script&lang=js&"
export * from "./TravelAssistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports